export default {
  common: {
    bingWallpaper: 'Bing Wallpaper',
    home: 'Home',
    about: 'Info',
    blog: 'Blog',
    refresh: 'Aggiorna pagina',
    loading: 'Caricamento...',
    year: '',
    preview: 'Anteprima',
    close: 'Chiudi',
    today: 'Oggi',
    yesterday: 'Ieri',
    dayBefore: 'L\'altroieri',
    daysAgo: 'giorni fa',
    monthsAgo: 'mesi fa',
    yearsAgo: 'anni fa',
    unknown: 'Sconosciuto',
    copySuccess: 'Copiato negli appunti',
    copyFail: 'Copia fallita, copia manualmente',
    language: 'Lingua',
    chinese: '中文',
    english: 'English',
    visitorCount: 'Sei il {count}° visitatore',
    copyright: 'Tutte le immagini di questo sito provengono da Bing Search, solo per uso didattico e personale',
    footerCopyright: 'Copyright © 2022 - {year}',
    openMenu: 'Apri menu',
    fatalError: 'Caricamento della pagina fallito, aggiorna e riprova',
    regionChina: 'Cina',
    regionGermany: 'Germania',
    regionCanada: 'Canada',
    regionUK: 'Regno Unito',
    regionIndia: 'India',
    regionUS: 'USA',
    regionFrance: 'Francia',
    regionItaly: 'Italia',
    regionJapan: 'Giappone',
    netdiskQuark: 'Quark Drive',
    netdiskAlipan: 'Alipan Drive',
    downloadViaNetdisk: 'Scarica sfondi HD',
    use: 'via'
  },
  wallpaper: {
    siteTitle: 'Bing Wallpaper - Microsoft Bing sfondi HD giornalieri da scaricare',
    siteDesc: 'Sito di download Bing Wallpaper, sincronizzando ogni giorno gli sfondi ufficiali giornalieri di {strong}Microsoft Bing{/strong}. Sfoglia e scarica sfondi Bing da {strong}Cina, USA, Giappone, Germania, Regno Unito, Francia, Italia, Canada, India{/strong} e altro. Supporta {strong}4K, 1920x1080, 1920x1200, 1366x768{/strong} e altre risoluzioni. Filtra per anno e {strong}download batch{/strong} di tutti gli sfondi. Tutti gli sfondi HD sono gratuiti, perfetti per sfondi desktop e telefono.',
    regionFilter: 'Regione',
    resolutionFilter: 'Risoluzione',
    yearFilter: 'Anno',
    selectRegion: 'Seleziona regione',
    selectResolution: 'Seleziona dimensione',
    selectYear: 'Seleziona anno',
    yearHint: 'Seleziona un anno per scaricare tutti gli sfondi di quell\'anno',
    currentFilter: 'Filtro attuale',
    totalWallpapers: '{count} sfondi',
    batchDownload: 'Download batch',
    downloadingWallpapers: 'Scaricamento sfondi...',
    packaging: 'Creazione pacchetto...',
    downloadSuccess: 'Scaricati {count} sfondi con successo',
    downloadFailed: 'Download batch fallito, riprova',
    noWallpapers: 'Nessuno sfondo disponibile per il download',
    noResults: 'Nessuno sfondo trovato che corrisponda ai criteri',
    clearFilters: 'Cancella filtri',
    filterRegion: 'Regione',
    filterYear: 'Anno',
    filterResolution: 'Dimensione',
    fetchFailed: 'Recupero dati sfondi fallito',
    fetchFailedNetwork: 'Recupero dati sfondi fallito, controlla la rete',
    unknownError: 'Errore sconosciuto',
    yearSuffix: ''
  },
  detail: {
    viewOriginal: 'Vedi originale',
    backHome: 'Torna alla home',
    downloadWallpaper: 'Download',
    copyLink: 'Copia link',
    viewFullscreen: 'Schermo intero',
    fullscreenTooltip: 'Clicca sull\'immagine dello sfondo per vederla a schermo intero',
    imageDescription: 'Descrizione',
    viewSource: 'Vedi fonte',
    openOriginal: 'Apri originale',
    copyrightInfo: 'Copyright',
    publishDate: 'Data',
    switchResolution: 'Cambia risoluzione',
    recommended: 'Altri sfondi',
    loadingDetail: 'Caricamento dettagli sfondo...',
    loadFailed: 'Caricamento fallito',
    reload: 'Riprova',
    loadingImage: 'Caricamento immagine...',
    imageLoadFailed: 'Caricamento immagine fallito',
    missingId: 'Parametro ID sfondo mancante',
    notFound: 'Sfondo non trovato',
    fetchDetailFailed: 'Recupero dettagli sfondo fallito',
    networkError: 'Errore di rete, controlla la connessione e riprova',
    resolutionSwitched: 'Risoluzione cambiata a {resolution}',
    startDownload: 'Avvio download sfondo',
    linkCopied: 'Link immagine copiato negli appunti',
    setDesktopHint: 'Fai clic con il tasto destro sull\'immagine e seleziona "Imposta come sfondo del desktop"',
    alreadyFavorited: 'Questo sfondo è già nei preferiti',
    favoriteSuccess: 'Sfondo aggiunto ai preferiti',
    copyFailedManual: 'Copia fallita, copia manualmente',
    wechatShareHint: 'Usa WeChat per scansionare e condividere',
    shareLinkCopied: 'Link di condivisione copiato',
    sharePrefix: 'Bing Wallpaper: '
  },
  about: {
    title: 'Su Bing Wallpaper',
    subtitle: 'Un bellissimo sito galleria di sfondi Bing con ricche funzionalità di navigazione, filtraggio e download.',
    timeline1Title: 'Tutte le pagine migliorate',
    timeline2Title: 'Prima versione, layout di base completato',
    timeline3Title: 'Bug di visualizzazione paginazione corretto',
    timeline4Title: 'Restyling completo',
    timeline4Item1: '1. Layout lista migliorato per migliore estetica e funzionamento più semplice',
    timeline4Item2: '2. Bug di paginazione corretto (non funziona più su un bug!!!)',
    timeline4Item3: '3. Filtraggio sfondi multidimensionale: regione, risoluzione, anno, ecc.',
    timeline4Item4: '4. Download batch con un clic di tutti gli sfondi di un anno filtrato',
    frontendProject: 'Progetto frontend: ',
    backendProject: 'Progetto backend: ',
    backendTutorial: 'Tutorial backend: ',
    selfBuildApi: 'API Bing autocostruita',
    postPara1: 'Il backend utilizza il database documentale {link}MongoDB{/link} per l\'archiviazione dei dati, lo strumento CI/CD illimitato {link2}GitHub Actions{/link2} per recuperare i dati giornalieri degli sfondi e memorizzarli in MongoDB, il framework Python asincrono ad alte prestazioni {link3}FastAPI{/link3} come backend, e {link4}Vercel{/link4} per la gestione serverless delle richieste. Il frontend utilizza il framework {link5}Element UI{/link5} per uno sviluppo rapido.',
    postPara2: 'Quando ho scoperto i sfondi Bing, ho visto molti bei sfondi su Bing e volevo un\'API per lo sfondo del mio blog. Più tardi ho imparato a costruire la mia API. Lungo il percorso ho imparato molto: la libreria pymongo, la configurazione di FastAPI, il design modulare di Python; frontend: layout di navigazione, integrazione di librerie di icone, uso di vue-router, wrapping di richieste axios, caricamento di paginazione.',
    postPara3: 'Ci sono state anche molte sfide. Ho cercato a fondo per scoprire che l\'API degli sfondi Bing supporta le regioni, ma la regione Cina veniva reindirizzata forzatamente. Con Vercel ci è voluto molto tempo per capire come gestire insieme frontend e backend. FastAPI aveva molte insidie. Ci è voluto molto tempo di ricerca e studio dei design altrui per completare il design modulare di Python. Ho letto {link}Element UI{/link} innumerevoli volte, ho incontrato molti bug, ho capito vue-router seguendo gli esempi ufficiali, e la paginazione aveva ancora un bug non risolto — PS: quel bug non può essere rimosso, il progetto funziona su di esso.',
    postPara4: '{strong}AI{/strong} è assolutamente incredibile!!!',
    postPara5: 'Ora, bing-wallpaper ha integrato il sistema di commenti {link}Twikoo{/link}. Sentitevi liberi di lasciare i vostri pensieri!'
  },
  seo: {
    siteName: 'Bing Wallpaper',
    defaultTitle: 'Bing Wallpaper | Sfondi HD giornalieri | Scarica sfondi da tutto il mondo',
    defaultDescription: 'Sito di download Bing Wallpaper, che fornisce sfondi HD giornalieri Microsoft Bing, supportando navigazione e download multi-regione e multi-risoluzione.',
    homeTitle: 'Bing Wallpaper | Sfondi HD giornalieri | Scarica sfondi da tutto il mondo',
    homeDescription: 'Sito di download Bing Wallpaper, che fornisce sfondi HD giornalieri Microsoft Bing, supportando 9 regioni tra cui Cina, USA, Giappone, Germania, Regno Unito, Francia, Italia, Canada, India. Offre 4K, 1920x1080 e altre risoluzioni, con download batch con un clic di tutti gli sfondi annuali.',
    regionTitle: 'Sfondi Bing regionali',
    regionDescription: 'Sfoglia e scarica sfondi Bing HD giornalieri regionali, supportando Cina, USA, Giappone, Germania, Regno Unito, Francia, Italia, Canada, India e altro.',
    aboutTitle: 'Su di noi',
    aboutDescription: 'Presentazione del sito Bing Wallpaper, che fornisce download di sfondi HD giornalieri Microsoft Bing, supportando navigazione e download multi-regione e multi-risoluzione. Tutte le immagini di questo sito provengono da Bing Search, solo per uso didattico e personale.',
    detailTitle: 'Dettagli sfondo',
    detailDescription: 'Pagina dettagli Bing Wallpaper, visualizza sfondi HD e supporta download in più risoluzioni.',
    regionSeoTitle: '{name} Bing Wallpaper - Download sfondo HD giornaliero {name}',
    regionSeoDesc: 'Download {name} Bing Wallpaper, che fornisce sfondi HD giornalieri Microsoft Bing regione {name}, supportando 4K, 1920x1080 e altre risoluzioni, download gratuito di sfondi HD per desktop.',
    regionSeoKeywords: '{name} Bing Wallpaper,sfondo {name},Bing Wallpaper,download sfondo HD',
    detailSeoTitle: '{title} - {region} Bing Wallpaper HD Download',
    detailSeoDesc: '{title}. {copyright} Pubblicato il {date}{region}. Bing Wallpaper offre 4K, 1920x1080 e altre risoluzioni per download gratuito.',
    detailSeoKeywords: '{title},{region} Bing Wallpaper,download sfondo HD,bing wallpaper,{date}',
    detailSeoKeywordsNoRegion: '{title},Bing Wallpaper,download sfondo HD,bing wallpaper,{date}',
    detailSeoTitleNoRegion: '{title} - Bing Wallpaper HD Download',
    detailSeoFromRegion: ' (regione: {name})',
    siteJsonLdDesc: 'Sito di download Bing Wallpaper, che fornisce sfondi HD giornalieri Microsoft Bing, supportando navigazione e download multi-regione e multi-risoluzione.',
    regionJsonLdDesc: 'Download sfondi Bing HD giornalieri regione {name}, supportando 4K, 1920x1080 e altre risoluzioni.',
    breadcrumbHome: 'Home',
    breadcrumbRegion: '{name} Bing Wallpaper',
    defaultKeywords: 'Bing Wallpaper,sfondo giornaliero,download sfondo HD,Microsoft Bing,Bing Wallpaper,sfondo HD,sfondo desktop,sfondo 4K,download sfondo',
    htmlTitle: 'Bing Wallpaper | Sfondi HD giornalieri | Scarica sfondi da tutto il mondo',
    htmlDescription: 'Sito di download Bing Wallpaper, che fornisce sfondi HD giornalieri Microsoft Bing, supportando 9 regioni tra cui Cina, USA, Giappone, Germania, Regno Unito, Francia, Italia, Canada, India. Offre 4K, 1920x1080 e altre risoluzioni, con download batch con un clic di tutti gli sfondi annuali.',
    htmlKeywords: 'Bing Wallpaper,sfondo giornaliero,download sfondo HD,Microsoft Bing,Bing Wallpaper,sfondo HD,sfondo desktop,sfondo 4K,download sfondo,Bing Wallpaper API,collezione sfondi,sfondo giornaliero',
    htmlH1: 'Bing Wallpaper - Microsoft Bing sfondi HD giornalieri da scaricare',
    htmlP: 'Sito di download Bing Wallpaper, che fornisce sfondi HD giornalieri Microsoft Bing, supportando 9 regioni tra cui Cina, USA, Giappone, Germania, Regno Unito, Francia e altro. Supporta 4K, 1920x1080 e altre risoluzioni, con download batch con un clic di tutti gli sfondi annuali.',
    twitterTitle: 'Bing Wallpaper | Sfondi HD giornalieri',
    twitterDesc: 'Download sfondi HD giornalieri Microsoft Bing, supportando multi-regione e multi-risoluzione.'
  }
}



// WEBPACK FOOTER //
// ./src/locale/it-IT.js